document.addEventListener("DOMContentLoaded", () => {
  const LOG = (...args) => console.log("[SAC]", ...args);

  // Elements (sticky bar controls)
  const stickyBar = document.getElementById("sticky-add-to-cart");
  const stickyVariantSelect = document.getElementById("sac-variant-select");
  const stickyAddToCartBtn = document.getElementById(
    "sticky-add-to-cart-button"
  );
  const stickyAddToCartBtnMobile = document.getElementById(
    "sticky-add-to-cart-button-mobile"
  );
  const stickyBuyNowBtnMobile = document.getElementById(
    "sticky-buy-now-button-mobile"
  );
  const sacImage = document.getElementById("sac-image");
  const sacPrice = document.getElementById("sac-price");
  const sacCompare = document.getElementById("sac-compare");
  const sacQtyDisplay = document.getElementById("sac-quantity-display");

  // Find main product form
  let mainForm =
    document.querySelector("form[action='/cart/add']") ||
    document.querySelector(
      'input[type="radio"][data-option-value-id], input[type="radio"][data-variant-id]'
    )?.form ||
    document.querySelector('form select[name="id"]')?.closest("form") ||
    null;

  // Quantity management
  const mainQtyInput = mainForm?.querySelector("input[name='quantity']");
  let quantity = 1;
  if (sacQtyDisplay)
    sacQtyDisplay.textContent = quantity < 10 ? "0" + quantity : quantity;

  function updateQuantityDisplay(qty) {
    quantity = Math.max(1, qty);
    if (sacQtyDisplay)
      sacQtyDisplay.textContent = quantity < 10 ? "0" + quantity : quantity;
    if (mainQtyInput) {
      mainQtyInput.value = quantity;
      mainQtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
    LOG("Quantity updated:", quantity);
  }

  // Bind +/- buttons to quantity update
  document.querySelectorAll(".qty-btn").forEach((btn) => {
    btn.addEventListener("click", () =>
      updateQuantityDisplay(
        btn.classList.contains("plus") ? quantity + 1 : quantity - 1
      )
    );
  });

  // Find option in sticky select by variant ID with fallbacks
  function findStickyOptionById(variantId) {
    if (!stickyVariantSelect) return null;
    let opt = stickyVariantSelect.querySelector(`option[value="${variantId}"]`);
    if (opt) return opt;
    return (
      Array.from(stickyVariantSelect.options).find((o) =>
        [
          o.dataset.optionValueId,
          o.dataset.variantId,
          o.dataset.productVariantId,
        ].includes(String(variantId))
      ) || null
    );
  }

  // Get selected variant from main form
  function getSelectedVariantFromMain() {
    if (!mainForm) return null;
    const idField = mainForm.querySelector(
      'input[name="id"], select[name="id"]'
    );
    if (idField?.value) return idField.value;
    const checkedRadio = mainForm.querySelector('input[type="radio"]:checked');
    if (checkedRadio)
      return (
        checkedRadio.dataset.variantId ||
        checkedRadio.dataset.optionValueId ||
        checkedRadio.value
      );
    return null;
  }

  let isSyncing = false;

  // Sync variant selection between main form and sticky bar
  function syncVariantSelection(variantId, source = "unknown") {
    if (!variantId || isSyncing) return;
    isSyncing = true;
    try {
      // Update sticky select
      if (stickyVariantSelect) {
        const opt = findStickyOptionById(variantId);
        if (opt) {
          stickyVariantSelect.value = opt.value;
          updateStickyUIFromOption(opt);
        }
      }
      // Update main form id input/select
      const idField = mainForm?.querySelector(
        'input[name="id"], select[name="id"]'
      );
      if (idField && String(idField.value) !== String(variantId)) {
        idField.value = variantId;
        idField.dispatchEvent(new Event("change", { bubbles: true }));
      }
      // If change from sticky select, check corresponding radio
      if (source === "sticky-select" && mainForm) {
        const radio = document.querySelector(
          `input[type="radio"][data-variant-id="${variantId}"]`
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
      resetAddToCartText();
    } catch (err) {
      console.error("[SAC] syncVariantSelection error", err);
    } finally {
      setTimeout(() => {
        isSyncing = false;
      }, 30);
    }
  }

  // Update sticky UI elements from selected option
  function updateStickyUIFromOption(option) {
    if (!option) return;
    if (sacPrice && option.dataset.price)
      sacPrice.textContent = option.dataset.price;
    if (sacImage && option.dataset.image) sacImage.src = option.dataset.image;
    if (sacCompare) {
      if (option.dataset.hasCompare === "true") {
        sacCompare.textContent = option.dataset.compare || "";
        sacCompare.removeAttribute("hidden");
      } else {
        sacCompare.setAttribute("hidden", true);
      }
    }
  }

  // When main form variant changes, sync to sticky bar
  function onMainVariantInput(e) {
    if (isSyncing) return;
    setTimeout(() => {
      const id = getSelectedVariantFromMain();
      if (id) syncVariantSelection(String(id), "main");
    }, 25);
  }

  // Bind change events to main form radios and select
  function bindMainVariantControls() {
    if (!mainForm) return;
    mainForm.querySelectorAll('input[type="radio"]').forEach((r) => {
      if (!r._sacBound) {
        r.addEventListener("change", onMainVariantInput);
        r.addEventListener("click", onMainVariantInput);
        r._sacBound = true;
      }
    });
    const mainSelect = mainForm.querySelector('select[name="id"]');
    if (mainSelect && !mainSelect._sacBound) {
      mainSelect.addEventListener("change", onMainVariantInput);
      mainSelect._sacBound = true;
    }
  }

  // Listen for changes on sticky variant select to sync to main form
  if (stickyVariantSelect) {
    stickyVariantSelect.addEventListener("change", (e) => {
      if (isSyncing) return;
      const chosenOpt = stickyVariantSelect.selectedOptions[0];
      const chosenId =
        chosenOpt?.dataset.variantId ||
        chosenOpt?.dataset.optionValueId ||
        stickyVariantSelect.value;
      if (chosenId) syncVariantSelection(String(chosenId), "sticky-select");
    });
  }

  // Listen for custom theme variant change events and sync
  [
    "variant-change",
    "variant:change",
    "variantChange",
    "variant:changed",
    "product:variant:change",
    "shopify:variant:change",
  ].forEach((ev) => {
    document.addEventListener(ev, (e) => {
      if (isSyncing) return;
      setTimeout(() => {
        const id =
          getSelectedVariantFromMain() ||
          e.detail?.variant?.id ||
          e.detail?.id ||
          e.detail?.variantId;
        if (id) syncVariantSelection(String(id), ev);
      }, 25);
    });
  });

  // Observe main form mutations to re-bind events and sync variants
  if (mainForm) {
    new MutationObserver(() => {
      bindMainVariantControls();
      const cur = getSelectedVariantFromMain();
      if (cur) syncVariantSelection(String(cur), "mutation-observer");
    }).observe(mainForm, { childList: true, subtree: true });
  } else {
    // Observe body to detect dynamically added main form
    new MutationObserver(() => {
      if (!mainForm) {
        mainForm =
          document.querySelector("form[action='/cart/add']") ||
          document.querySelector('form select[name="id"]')?.closest("form") ||
          mainForm;
        if (mainForm) bindMainVariantControls();
      } else {
        bindMainVariantControls();
      }
      const cur = getSelectedVariantFromMain();
      if (cur) syncVariantSelection(String(cur), "body-mutation-observer");
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Initial setup
  bindMainVariantControls();
  const initialVariant = getSelectedVariantFromMain();
  if (initialVariant) {
    syncVariantSelection(String(initialVariant), "init");
  } else if (stickyVariantSelect?.value) {
    const chosenOpt = stickyVariantSelect.selectedOptions[0];
    const chosenId =
      chosenOpt?.dataset.optionValueId ||
      chosenOpt?.dataset.variantId ||
      stickyVariantSelect.value;
    if (chosenId) syncVariantSelection(String(chosenId), "init-sticky");
  }

  // Show/hide sticky bar based on scroll + ATC button visibility
  const mainAddToCartBtn = mainForm?.querySelector("button[type='submit']");

  function checkStickyVisibility(entry) {
    const scrolledEnough = window.scrollY > 400; // show only after 100px scroll
    const atcVisible = entry?.isIntersecting; // true if main ATC is in viewport
    const nearBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;

    if (scrolledEnough && !atcVisible && !nearBottom) {
      stickyBar?.classList.add("show");
    } else {
      stickyBar?.classList.remove("show");
    }
  }

  if (mainAddToCartBtn && "IntersectionObserver" in window) {
    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          checkStickyVisibility(entry);
        },
        { threshold: 0 }
      );

      observer.observe(mainAddToCartBtn);

      // also check on scroll for bottom detection
      window.addEventListener("scroll", () => {
        checkStickyVisibility({
          isIntersecting: observer.takeRecords()[0]?.isIntersecting,
        });
      });
    } catch {
      window.addEventListener("scroll", () => {
        const scrolledEnough = window.scrollY > 400;
        const nearBottom =
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 50;
        stickyBar?.classList.toggle("show", scrolledEnough && !nearBottom);
      });
    }
  } else {
    window.addEventListener("scroll", () => {
      const scrolledEnough = window.scrollY > 400;
      const nearBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;
      stickyBar?.classList.toggle("show", scrolledEnough && !nearBottom);
    });
  }

  // Refresh cart drawer and bubble UI after add to cart
  async function refreshCartSections(openDrawer = true) {
    try {
      const res = await fetch(
        `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
      );
      const data = await res.json();

      // Update cart drawer
      const newDrawer = new DOMParser()
        .parseFromString(data["cart-drawer"] || "", "text/html")
        .querySelector("cart-drawer");
      const currentDrawer = document.querySelector("cart-drawer");
      if (newDrawer && currentDrawer) {
        if (currentDrawer.classList.contains("is-empty")) {
          currentDrawer.replaceWith(newDrawer);
        } else {
          ["cart-drawer-items", ".cart-drawer__footer"].forEach((sel) => {
            const n = newDrawer.querySelector(sel),
              o = currentDrawer.querySelector(sel);
            if (n && o) o.replaceWith(n);
          });
        }
        if (openDrawer)
          document.querySelector("cart-drawer")?.classList.add("active");
      }
      
      // ====calling progress bar function=====
      window.updateFreebieProgress();

      // Update cart count bubble
      const newBubble = new DOMParser()
        .parseFromString(data["cart-icon-bubble"] || "", "text/html")
        .querySelector(".cart-count-bubble");
      const oldBubble = document.querySelector(".cart-count-bubble");
      if (newBubble && oldBubble) {
        const [newCount, newHidden] = newBubble.querySelectorAll("span");
        const [oldCount, oldHidden] = oldBubble.querySelectorAll("span");
        if (newCount && oldCount) oldCount.innerText = newCount.innerText;
        if (newHidden && oldHidden) oldHidden.innerText = newHidden.innerText;
      }
    } catch (err) {
      console.error("[SAC] refreshCartSections error", err);
    }
  }

  // Handle Add to Cart button click
  async function handleStickyAddToCart(e) {
    e.preventDefault();
    // const selectedId = stickyVariantSelect?.selectedOptions[0]?.dataset?.optionValueId ||
    // stickyVariantSelect?.selectedOptions[0]?.dataset?.variantId ||
    // stickyVariantSelect?.value ||
    // getSelectedVariantFromMain();
    const selectedId = document.querySelector(
      '#sticky-product-form [name="id"]'
    ).value;
    const btn = e.currentTarget;
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: selectedId, quantity }),
      });
      if (!res.ok) throw new Error("Add to cart failed");
      btn.textContent = "Added";
      await refreshCartSections(true);
    } catch (err) {
      console.error("[SAC] Add to cart error", err);
    }
  }

  function resetAddToCartText() {
    if (stickyAddToCartBtn) stickyAddToCartBtn.textContent = "Add to Cart";
    if (stickyAddToCartBtnMobile)
      stickyAddToCartBtnMobile.textContent = "Add to Cart";
  }

  document
    .getElementById("sticky-add-to-cart-button")
    ?.addEventListener("click", handleStickyAddToCart);
  document
    .getElementById("sticky-add-to-cart-button-mobile")
    ?.addEventListener("click", handleStickyAddToCart);
  // stickyBuyNowBtnMobile?.addEventListener('click', handleStickyBuyNow);
});

// ==========Sticky navbar=========
document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".header__inline-menu");
  const mobileNav = document.querySelector(".header-wrapper");
  if (nav) {
    const navOffset = nav.offsetTop;
    window.addEventListener("scroll", function () {
      if (window.scrollY > navOffset + 10) {
        nav.classList.add("fixed-nav");
      } else {
        nav.classList.remove("fixed-nav");
      }
    });
  }
  if (mobileNav) {
    const navOffset = mobileNav.offsetTop;
    window.addEventListener("scroll", function () {
      if (window.scrollY > navOffset + 10) {
        mobileNav.classList.add("fixed-nav");
      } else {
        mobileNav.classList.remove("fixed-nav");
      }
    });
  }
});

function sliderAuto(slider, miliseconds) {
 const slidesCount = slider.track.childElementCount;
 let slideTimeout = null;
 let nextIndex = 1;

 function slide () {
   slideTimeout = setTimeout(
     function () {
       if (nextIndex >= slidesCount ) {
         nextIndex = 0;
       }
       slider.scrollItem(nextIndex++);
     },
     miliseconds
   );
 }
 slider.ele.addEventListener('glider-animated', function() {
   window.clearInterval(slideTimeout);
   slide();
 });
 slide();
}

// Homepage glider-slider

// Mobile Icons
var top_mobile_icons = document.querySelectorAll('.top_icon_mobile_main');
if(top_mobile_icons.length != 0) {
  top_mobile_icons.forEach((section) => {
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 4,
      scrollLock: false,
      direction: 'vertical',
      rewind: true,
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 4000);
  })
}

// Slideshow
var homepageSlider = document.querySelectorAll('.cstm_slideshow_main_container');
if(homepageSlider.length != 0) {
  homepageSlider.forEach((section) => {
    const prev = section.closest(".banner-slider").querySelector(".slick-prev-btn-slideshow"),
      next = section.closest(".banner-slider").querySelector(".slick-next-btn-slideshow"),
        dots = section.closest(".banner-slider").querySelector(".glider-dots");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 1,
      direction: 'vertical',
      rewind: true,
      arrows: {
        prev: prev,
        next: next
      },
      dots: dots
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 4000);
  })
}

// Custom Featured Collection
var featuredCollections = document.querySelectorAll('.cstm_featured_collection_main_products');
if(featuredCollections.length != 0) {
  featuredCollections.forEach((section) => {
    const prev = section.closest(".cstm_featured_collection_main").querySelector(".slick-prev-btn"),
      next = section.closest(".cstm_featured_collection_main").querySelector(".slick-next-btn"),
        dots = section.closest(".cstm_featured_collection_main").querySelector(".glider-dots"),
          slidesToShow = section.getAttribute("slides-to-show"),
            autoScroll = section.getAttribute("data-auto-scroll");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 2,
      direction: 'vertical',
      rewind: true,
      arrows: {
        prev: prev,
        next: next
      },
      dots: dots,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: Number(slidesToShow),
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
    if (autoScroll == "true") {
      sliderAuto(glider, 4000);
    }
  })
}

// Collection with image
var collectionWithImage = document.querySelectorAll('.new_lanches');
if(collectionWithImage.length != 0) {
  collectionWithImage.forEach((section) => {
    const prev = section.closest(".right_part").querySelector(".slick-prev"),
      next = section.closest(".right_part").querySelector(".slick-next");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 2,
      direction: 'vertical',
      rewind: true,
      arrows: {
        prev: prev,
        next: next
      },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 4000);
  })
}

// Homepage tabs
var homePageTabs = document.querySelectorAll('.clickable_tab_main_slider');
if(homePageTabs.length != 0) {
  homePageTabs.forEach((section) => {
    const dots = section.closest(".clickable_tab_main").querySelector(".glider-dots");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 1,
      direction: 'vertical',
      rewind: true,
      dots: dots,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 4000);
  })
}

// Testimonials
var testimonials = document.querySelectorAll('.main_testimonial_parent .testimonial-slider');
if(testimonials.length != 0) {
  testimonials.forEach((section) => {
    const dots = section.closest(".main_testimonial_parent").querySelector(".glider-dots");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 1,
      direction: 'vertical',
      rewind: true,
      dots: dots,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
    // sliderAuto(glider, 2000);
  })
}

// Multicolumn slide
var multiColumnSlide = document.querySelectorAll('.cstm_multicolumn_slide_main_container');
if(multiColumnSlide.length != 0) {
  multiColumnSlide.forEach((section) => {
    const dots = section.closest(".cstm_multicolumn_slide_main").querySelector(".glider-dots");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 1,
      direction: 'vertical',
      rewind: true,
      dots: dots,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 4000);
  })
}

// Headline
var headline = document.querySelectorAll('.headline-images');
if(headline.length != 0) {
  headline.forEach((section) => {
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 2,
      direction: 'vertical',
      rewind: true,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 981,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
    sliderAuto(glider, 4000);
  })
}

// Homepage glider-slider end

// Wellness University glider-slider Start

var headline = document.querySelectorAll('.slider-container');
if(headline.length != 0) {
  headline.forEach((section) => {
    const prev = section.closest(".custom_buttom").querySelector(".cstm_prev"),
      next = section.closest(".custom_buttom").querySelector(".cstm_next");
    new Glider(section, {
      slidesToScroll: 1,
      slidesToShow: 1,
      direction: 'vertical',
      rewind: true,
      arrows: {
        prev: prev,
        next: next
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    const glider = new Glider(section, {});
  })
}

// Wellness University glider-slider End